module.exports = __webpack_public_path__ + "static/opener-text-db795e6f53688c71b57fd3837e72b362.png";